/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions used to manipulate application state
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import SplashScreen from 'components/content/splash/splash';
import { setTotalFrameCount, advanceFrame } from 'redux/actions/content_status';



/* ========== ~~~~~~~~~~ SPLASH SCREEN: PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentStatus, settings, contentData, embedStatus, sessionStatus, screenStatus }, { contentId }) => ({
  isActiveContent: contentStatus[contentId]['status'] === 'active',
  currentContentStatusType: contentStatus[contentId]['type'],
  logoText: settings.contentSettings[contentId].elements.companyLogo.text,
  partnerLogoSrc: settings.embedSettings.elements.partnerLogo.src,
  partnerLogoUrl: settings.embedSettings.elements.partnerLogo.url,
  partnerLogoText: settings.embedSettings.elements.partnerLogo.text,
  inView: embedStatus.inView,
  inViewRecorded: embedStatus.inViewRecorded,
  inViewSettings: settings.embedSettings.inView,
  cookieCheckDone: sessionStatus.cookieCheckDone,
  integrationType: embedStatus.integrationType,
  enableInsticatorBranding: settings.embedSettings.enableInsticatorBranding,
  screenName: screenStatus.name
});


// map actions
const mapDispatchToProps = dispatch => ({
  setTotalFrameCount: (contentId, totalFrameCount) => dispatch(setTotalFrameCount(contentId, totalFrameCount)),
  advanceFrame: contentId => dispatch(advanceFrame(contentId))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SplashScreen);
